import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useIntl } from 'react-intl';
import { Button, Collapse } from 'reactstrap';
import { connect } from 'react-redux';

import { showModal, showModalTop } from '../../../actions';

import { userIsAdmin, userIsManager } from '../../../helpers/Auth';
import { getInitialOpenOnboardingStep, isOnboardingStepCompleted } from '../../../helpers/Onboarding';

import OnboardingStepHeader from './StepHeader';
import OnboardingSkipButton from './SkipButton';

const OnboardingCreateCollection = ({
  openCollectionEditModal,
  openCollectionCreatedModal,
  slug,
}) => {
  const intl = useIntl();

  const [isOpen, setIsOpen] = useState(getInitialOpenOnboardingStep() === slug);

  const isCompleted = isOnboardingStepCompleted(slug);
  const initialOpenStep = getInitialOpenOnboardingStep();

  const afterCreateCollection = (data) => {
    openCollectionCreatedModal({
      collectionUuid: data.uuid,
    });
  };

  useEffect(() => {
    if (initialOpenStep === slug) {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  }, [slug, initialOpenStep]);

  if (!(userIsAdmin() || userIsManager())) {
    return null;
  }

  return (
    <div className={classnames('onboarding-step', { 'onboarding-step-next': initialOpenStep === slug })}>
      <OnboardingStepHeader
        isOpen={isOpen}
        handleOpen={setIsOpen}
        title={intl.formatMessage({ defaultMessage: 'Make your first Collection' })}
        subtitle={intl.formatMessage({ defaultMessage: 'Create Collections to organize your files. One file can live in multiple Collections without being duplicated!' })}
        isCompleted={isCompleted}
      />
      <Collapse isOpen={isOpen} className="onboarding-step-collapse">
        <div>
          <div className="onboarding-step-collapse-buttons">
            <div>
              <Button
                color="primary"
                onClick={() => {
                  openCollectionEditModal({
                    className: 'modal-new-collection',
                    afterCreateCollection,
                  });
                }}
              >
                <i className="far fa-plus" />
                {intl.formatMessage({ defaultMessage: 'Create a collection' })}
              </Button>
              <Button
                color="link"
                tag="a"
                href="https://help.stockpress.co/en/articles/5936618-creating-and-deleting-collections"
                target="_blank"
              >
                <i className="far fa-book mr-1" />
                {intl.formatMessage({ defaultMessage: 'Find out more' })}
              </Button>
            </div>
            <div>
              <div>
                <OnboardingSkipButton slug={slug} isCompleted={isCompleted} />
              </div>
            </div>
          </div>
        </div>
      </Collapse>
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  openCollectionEditModal: (params) => {
    dispatch(showModal('CollectionEditModal', params));
  },
  openCollectionCreatedModal: (params) => {
    dispatch(showModalTop('CollectionCreatedModal', params));
  },
});

OnboardingCreateCollection.propTypes = {
  openCollectionEditModal: PropTypes.func.isRequired,
  openCollectionCreatedModal: PropTypes.func.isRequired,
  slug: PropTypes.string.isRequired,
};

export default connect(null, mapDispatchToProps)(OnboardingCreateCollection);
